import React from "react";
import "./Account.css";
import { useAuth } from "..//Context/AuthContext";
import { updatePassword, deleteUser } from "firebase/auth";
import { auth } from "../firebase";

export default function Account() {
  const { user } = useAuth();

  const handleChangePassword = async () => {
    const newPassword = prompt("Enter new password");

    if (!newPassword) return;

    try {
      await updatePassword(auth.currentUser, newPassword);
      alert("Password updated successfully");
    } catch (error) {
      alert(error.message);
    }
  };

  const handleDeleteAccount = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete your account?"
    );

    if (!confirmDelete) return;

    try {
      await deleteUser(auth.currentUser);
      alert("Account deleted");
    } catch (error) {
      alert(error.message);
    }
  };

  if (!user) {
    return (
      <section className="account-page">
        <h2>Please login first</h2>
      </section>
    );
  }

  return (
    <section className="account-page">
      <div className="account-info">
        <h1>Account Details</h1>
        <hr />

        <div className="name">
          Name : {user.displayName ? user.name : "User"}
        </div>

        <div className="email">
          Email : {user.email}
        </div>

        <div className="accounts-manage">
          <button onClick={handleChangePassword}>
            Change Password
          </button>

          <button onClick={handleDeleteAccount}>
            Delete Account
          </button>
        </div>
      </div>
    </section>
  );
}